module.exports = __webpack_public_path__ + "img/2-1.04b95b54.png";